<div class="top-bar">
  <h2>{{ title | translate }}</h2>
  <div class="actions">
    @if (showHomeBtn) {
      <img class="icon-xl" [src]="'burger.svg' | themeSource" (click)="backToHome()">
    }
    <img class="icon-xl" (click)="close()" [src]="'close.svg' | themeSource">
  </div>
</div>
